module.exports = __webpack_public_path__ + "static/media/7.9fb2e4ec.jpg";